import { Injectable } from '@angular/core';
import { SICOM_PATHS } from 'src/sicom-paths';
import { AbstractReportJobService } from '@/core/services/report-job/abstract-report-job.service';

@Injectable({ providedIn: 'root' })
export class OficioConfirmacaoCancelamentoIncSecundariaMedicoJobService extends AbstractReportJobService {
    protected readonly sessionKey = 'oficio-confirmacao-cancelamento-inc-secundaria-medico-jobId';
    protected readonly baseUrl = SICOM_PATHS.registro.medico.reports.oficioConfirmacaoCancelamentoIncSecundariaMedico;
}
